// Экран «Квартиры» — двенадцатый экран нового фронта (п.20, 2026-09-07).
// Зеркало справочника квартир из «Базы», только чтение; показывается первый
// выбранный корпус. Кнопка «Обновить из Базы» перечитывает зеркало.
import { useCallback, useEffect, useState } from 'react';
import { call, p, type Data } from '../api';
import type { ShellCtx } from '../shell';

type Kvartira = Data<'/api/projects/{pid}/kvartiry', 'get'>[number];

export function Kvart({ ctx }: { ctx: ShellCtx }) {
  const [rows, setRows] = useState<Kvartira[]>([]);
  const [busy, setBusy] = useState(false);
  const korpus = ctx.korpus || '';

  const load = useCallback(async () => {
    if (!korpus) { setRows([]); return; }
    const r = await call<Kvartira[]>('get', p('/api/projects/{pid}/kvartiry', { pid: ctx.pid })
      + '?korpus=' + encodeURIComponent(korpus));
    if (!r.ok) { ctx.onError?.(r.error.message); return; }
    setRows(r.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.pid, korpus, ctx.reloadToken]);
  useEffect(() => { void load(); }, [load]);

  async function refresh() {
    setBusy(true);
    const r = await call<{ kvartir: number; propuscheno_strok: number }>('post',
      p('/api/projects/{pid}/kvartiry/refresh', { pid: ctx.pid }), {});
    setBusy(false);
    if (!r.ok) { ctx.onError?.(r.error.message); return; }
    ctx.onError?.('');
    ctx.onSaved?.('Квартиры обновлены из Базы: ' + r.data.kvartir
      + (r.data.propuscheno_strok ? ', пропущено строк: ' + r.data.propuscheno_strok : ''));
    void load();
  }

  const link = (u?: string | null, t?: string) =>
    u ? <a href={u} target="_blank" rel="noopener">{t}</a> : null;

  return (
    <div>
      <div className="bar actbar">
        <span className="muted">({rows.length})</span>
        <span className="grow" />
        {ctx.canPlan && <button className="sec" disabled={busy} onClick={() => void refresh()}>Обновить из Базы</button>}
      </div>
      <div className="tbl" style={{ maxHeight: '76vh' }}>
        <table>
          <thead>
            <tr>
              <th>Этаж</th><th>№ на этаже</th><th>Строительный №</th><th>Алимак</th>
              <th>Комментарий</th><th>РД</th><th>Паспорт</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((q, i) => (
              <tr key={i}>
                <td className="num">{q.etazh}</td>
                <td className="num">{q.nomer ?? ''}</td>
                <td>{q.str_nomer || ''}</td>
                <td>{q.alimak || ''}</td>
                <td>{q.kommentarij || ''}</td>
                <td>{String(q.rd || '').startsWith('http') ? link(q.rd, 'РД') : (q.rd || '')}</td>
                <td>{link(q.pasport, 'открыть')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="muted" style={{ marginTop: 8 }}>
        Справочник квартир ведётся в «Базе» и зеркалится сюда — правка здесь появится после переноса Базы.
      </div>
    </div>
  );
}
